
import { useState, useEffect } from "react";
import { Testimonial } from "@/components/index/testimonials/types";
import { getAllTestimonials, getFeaturedTestimonials } from "@/services/testimonialService";

export const useAllTestimonials = () => {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      setLoading(true);
      const response = await getAllTestimonials();
      
      if (response.error) {
        setError(response.error);
      } else {
        setTestimonials(response.data);
        setError(null);
      }
      
      setLoading(false);
    };

    fetchTestimonials();
  }, []);

  return { testimonials, loading, error };
};

export const useFeaturedTestimonials = (limit: number = 3) => {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFeaturedTestimonials = async () => {
      setLoading(true);
      const response = await getFeaturedTestimonials(limit);
      
      if (response.error) {
        setError(response.error);
      } else {
        setTestimonials(response.data);
        setError(null);
      }
      
      setLoading(false);
    };

    fetchFeaturedTestimonials();
  }, [limit]);

  return { testimonials, loading, error };
};
